import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useNewsRouter } from '../../shared/hooks/useNewsRouter';
export const NewsListContext = createContext({
    config: {},
    data: {},
    flags: {},
    handlers: {},
    routes: {},
    updateNewsList: () => {
        throw new Error('updateNewsList is not implemented');
    },
});
export const useNewsListContext = () => useContext(NewsListContext);
export const NewsListProvider = ({ children, config: initialConfig, data: initialData, flags: initialFlags, handlers: initialHandlers, }) => {
    const [config, setConfig] = useState(() => initialConfig);
    const [data, setData] = useState(() => initialData);
    const [handlers, setHandlers] = useState(() => initialHandlers);
    const [flags, setFlags] = useState(() => initialFlags);
    const routes = useNewsRouter();
    useEffect(() => {
        setConfig(initialConfig);
        setData(initialData);
        setFlags(initialFlags);
        setHandlers(initialHandlers);
    }, [initialConfig, initialData, initialFlags, initialHandlers]);
    const value = useMemo(() => ({
        config,
        data,
        flags,
        handlers,
        routes,
        updateNewsList: (newsList) => {
            if (newsList.config) {
                setConfig((prev) => (Object.assign(Object.assign({}, prev), newsList.config)));
            }
            if (newsList.data) {
                setData((prev) => (Object.assign(Object.assign({}, prev), newsList.data)));
            }
            if (newsList.flags) {
                setFlags((prev) => (Object.assign(Object.assign({}, prev), newsList.flags)));
            }
            if (newsList.handlers) {
                setHandlers((prev) => (Object.assign(Object.assign({}, prev), newsList.handlers)));
            }
        },
    }), [config, data, flags, handlers, routes]);
    return (_jsx(NewsListContext.Provider, { value: value, children: children }));
};
//# sourceMappingURL=NewsListContext.js.map